/**
 * 担当者候補から除外するユーザーの判定。
 *
 * CTS連携用のシステムアカウントは担当者として選べないようにする。
 * calendarApi（一覧取得時）と EventDialog（表示直前）の両方で
 * 同じ判定をしていたためここへ集約した。
 */

/** ユーザー名・表示名にこれらを含むアカウントは担当者候補から外す */
export const EXCLUDED_ASSIGNABLE_USER_KEYWORDS = ['newsglobe', 'neckisya', 'necdesk'];

/** 担当者候補から除外すべきユーザーかどうか */
export const shouldExcludeAssignableUser = (user: { username?: string; name?: string }): boolean => {
  const username = String(user?.username || '').toLowerCase();
  const name = String(user?.name || '').toLowerCase();
  return EXCLUDED_ASSIGNABLE_USER_KEYWORDS.some((keyword) => (
    username.includes(keyword) || name.includes(keyword)
  ));
};
